// export const environment = {
//   production: false,
//   apiBaseUrl: 'https://cwindia-api.creatorofone.in/bp/',
//   vmsBaseUrl:'https://cwindia-api.creatorofone.in/vms/',
//   vmsBridgePlusBaseUrl:'https://apiindia-sitin-vms.creatorofone.in/',
//   eventBaseUrl:'https://cwindia-api.creatorofone.in/events/',
//   domain: "capitaland.com",
//   tenant: 'bd934458-d635-4e43-ae98-91e5617aff09',
//   clientId: 'e0b28e13-4dc7-4f2e-8085-29c1fa92ab88',
//   redirectUri: 'https://tenantadmin.creatorofone.in/overview',
//   nonRfIdParks: 'baaea373-d5a0-4388-ba57-57e6f5513264', //92f6abdc-731a-4544-9675-ef3ac8dcdc18
//   officeRndClientId: 'CglhiTG9uTjsQYyD',
//   officeRndClientSecret: 'jy9qS4XJyFjFinEYwNAolrxyzat5HxN0',
// };

export const environment = {
  production: true,
  apiBaseUrlUserMgmt: 'https://csw-api.indusnettechnologies.com/user-mgnt/',
  facilityBaseUrl: 'https://csw-api.indusnettechnologies.com/facility/',

  apiBaseUrl: 'https://csw-api.indusnettechnologies.com/', //for uat
  vmsBaseUrl: 'https://csw-api.indusnettechnologies.com/vms/', //for uat
  vmsBridgePlusBaseUrl: 'https://csw-api.indusnettechnologies.com/vms/', // for uat.
  eventBaseUrl: 'https://csw-api.indusnettechnologies.com/events/', //for uat
  apiBaseUrlPms: 'https://csw-api.indusnettechnologies.com/pms/', // for uat

  domain: "indusnettechnologies.com",
  tenant: 'bd934458-d635-4e43-ae98-91e5617aff09',
  clientId: '9648ae19-939b-490f-a68b-0e1e16c347e9',
  redirectUri: 'https://csw-ta.indusnettechnologies.com/overview',

  nonRfIdParks: 'baaea373-d5a0-4388-ba57-57e6f5513264', //92f6abdc-731a-4544-9675-ef3ac8dcdc18

  officeRndClientId: 'CglhiTG9uTjsQYyD',
  officeRndClientSecret: 'jy9qS4XJyFjFinEYwNAolrxyzat5HxN0',
};

